"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var bluebird_1 = __importDefault(require("bluebird"));

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");
/**
 * Procedure responsible for modifying any exemption related to percentage restrictions
 */


var ModifyPercentageExemptions =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(ModifyPercentageExemptions, _Procedure_1$Procedur);

  function ModifyPercentageExemptions() {
    var _this;

    _classCallCheck(this, ModifyPercentageExemptions);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModifyPercentageExemptions).apply(this, arguments));
    _this.type = types_1.ProcedureType.ModifyPercentageExemptions;
    return _this;
  }
  /**
   * - Update the list of addresses that are exempt from percentage restrictions (if supplied)
   * - Modify whether primary issuance is exempt from percentage restrictions (if supplied)
   *
   * Note that this procedure will fail if:
   * - The data supplied to it is no different to the data in the contract
   * - The Security Token doesn't exist
   * - The Percentage Ownership Restrictions feature isn't enabled
   */


  _createClass(ModifyPercentageExemptions, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var _this$args, symbol, _this$args$whitelistE, whitelistEntries, allowPrimaryIssuance, contractWrappers, percentageTransferManagerModule, investors, valids, _ref, _ref2, entriesToChange, isPrimaryIssuanceAllowed;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, _this$args$whitelistE = _this$args.whitelistEntries, whitelistEntries = _this$args$whitelistE === void 0 ? [] : _this$args$whitelistE, allowPrimaryIssuance = _this$args.allowPrimaryIssuance;
                contractWrappers = this.context.contractWrappers;

                if (!(!whitelistEntries.length && allowPrimaryIssuance === undefined)) {
                  _context2.next = 4;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Nothing to modify. Please pass the corresponding parameters'
                });

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](4);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                _context2.next = 14;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.PercentageTransferManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 14:
                percentageTransferManagerModule = _context2.sent[0];

                if (percentageTransferManagerModule) {
                  _context2.next = 17;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'You must enable the PercentageOwnershipRestrictions Feature'
                });

              case 17:
                investors = [];
                valids = [];
                _context2.next = 21;
                return Promise.all([bluebird_1.default.filter(whitelistEntries, function (_ref3) {
                  var address = _ref3.address,
                      whitelisted = _ref3.whitelisted;
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee() {
                    var isWhitelisted;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return percentageTransferManagerModule.whitelist({
                              investorAddress: address
                            });

                          case 2:
                            isWhitelisted = _context.sent;
                            return _context.abrupt("return", isWhitelisted !== whitelisted);

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                }), percentageTransferManagerModule.allowPrimaryIssuance()]);

              case 21:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 2);
                entriesToChange = _ref2[0];
                isPrimaryIssuanceAllowed = _ref2[1];

                if (entriesToChange.length) {
                  _context2.next = 30;
                  break;
                }

                if (!whitelistEntries.length) {
                  _context2.next = 28;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Whitelist data passed is the same data currently in the contract'
                });

              case 28:
                _context2.next = 33;
                break;

              case 30:
                entriesToChange.forEach(function (_ref4) {
                  var address = _ref4.address,
                      whitelisted = _ref4.whitelisted;
                  investors.push(address);
                  valids.push(whitelisted);
                });
                _context2.next = 33;
                return this.addTransaction(percentageTransferManagerModule.modifyWhitelistMulti, {
                  tag: types_1.PolyTransactionTag.ModifyWhitelistMulti
                })({
                  investors: investors,
                  valids: valids
                });

              case 33:
                if (!(allowPrimaryIssuance !== undefined && allowPrimaryIssuance !== isPrimaryIssuanceAllowed)) {
                  _context2.next = 36;
                  break;
                }

                _context2.next = 36;
                return this.addTransaction(percentageTransferManagerModule.setAllowPrimaryIssuance, {
                  tag: types_1.PolyTransactionTag.SetAllowPrimaryIssuance
                })({
                  allowPrimaryIssuance: allowPrimaryIssuance
                });

              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));
    }
  }]);

  return ModifyPercentageExemptions;
}(Procedure_1.Procedure);

exports.ModifyPercentageExemptions = ModifyPercentageExemptions;